// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatAutoCleanupSettingsItem__title-cb065f {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatAutoCleanupSettings/ChatAutoCleanupSettingsItem/ChatAutoCleanupSettingsItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF","sourcesContent":[".title {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `ChatAutoCleanupSettingsItem__title-cb065f`
};
module.exports = ___CSS_LOADER_EXPORT___;
